import { GetApiCall, DeleteApiCall } from "./axiosSetup";

export const GET_ACTIVE_COUPON = '/coupons/get-active-coupon';
export const ACTIVATE_COUPON = '/coupons/redeem-coupon';
export const CANCEL_COUPON = '/coupons/cancel-coupon';
export const GET_PLAYER_COUPONS = '/coupons/get-player-coupon';

export const GetActiveCoupon = async () => GetApiCall(GET_ACTIVE_COUPON);
export const ActivateCoupon = async (data) => GetApiCall(ACTIVATE_COUPON, data);
export const CancelCoupon = async (data) => DeleteApiCall(CANCEL_COUPON, data);
export const GetPlayerCoupons = async () => GetApiCall(GET_PLAYER_COUPONS);